import {
  Box,
  Card,
  Grid,
  ListContext,
  PAGE_DEFAULT,
  PAGE_SIZE_UNLIMITED,
  pn,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  useTheme,
} from "@compass/core";
import { DataCenterFileTask as DataCenterFileTaskModel } from "generated/openApi";
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import ApiService from "services/apiService";
import { DataCenterFileTask } from "./DataCenterFileTask";

export const DataCenterFileTasks = (props: { dataCenterFileId: number }) => {
  const theme = useTheme();
  const [tasks, setTasks] = useState<DataCenterFileTaskModel[]>([]);
  const [selectedTask, setSelectedTask] = useState<DataCenterFileTaskModel>(); // change

  useEffect(() => {
    if (props.dataCenterFileId > 0) getTasks(props.dataCenterFileId);
  }, []);

  const getTasks = (dataCenterFileId: number) => {
    ApiService.dataCenterFileTasks
      .getList({
        page: PAGE_DEFAULT,
        pageSize: PAGE_SIZE_UNLIMITED,
        sortObjects: [{ property: pn<DataCenterFileTaskModel>("createdDate"), isDesc: false }],
        taskFilter: { dataCenterFileId: dataCenterFileId, includeInfoTasks: false },
      })
      .then((response) => {
        const listItems = response;
        setTasks(listItems);

        if (selectedTask) setSelectedTask(listItems.find((x) => x.id === selectedTask.id));
        else if (listItems.length >= 1) setSelectedTask(listItems[0]);
      });
  };

  return (
    <Card sx={{ height: "100%" }}>
      {!tasks && (
        <Box display="flex" height="100%" alignItems={"center"} justifyContent="center">
          <Typography variant="body1">No Tasks have been added by Cobro staff yet.</Typography>
        </Box>
      )}

      <Stack display="flex" direction={"column"} spacing="lg">
        <Box>
          <Grid container spacing="sm">
            <ToggleButtonGroup value={selectedTask} exclusive>
              {tasks.map((task) => (
                <ToggleButton
                  key={task.id}
                  value={task}
                  onClick={() => setSelectedTask(task)}
                  sx={{ minWidth: "100px" }}
                  // @ts-ignore
                  color={task.status?.reactColor}
                >
                  <Typography
                    color={task.status?.reactColor && theme.palette[task.status?.reactColor].main}
                    fontWeight="medium"
                    fontSize="0.9rem"
                  >
                    {task.name}
                  </Typography>
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </Grid>
        </Box>

        {selectedTask && (
          <Box overflow="auto">
            <DataCenterFileTask task={selectedTask} getTasks={() => getTasks(props.dataCenterFileId)} />
          </Box>
        )}
      </Stack>

      <ListContext.Provider value={{ loadList: () => getTasks(props.dataCenterFileId) }}>
        <Outlet />
      </ListContext.Provider>
    </Card>
  );
};
